import axios from 'axios';

/**
 * Shared utility functions for email campaign management
 * Used by multiple components to manage campaign data
 */
export const campaignUtils = {
  /**
   * Load campaigns from the API
   * @returns {Promise<Array>} Promise that resolves to array of campaigns
   */
  async loadCampaigns({ page = 1, limit = 20, folderId = null, search = '' } = {}) {
    try {
      const params = {
        if_need_remain_count: true,
        limit,
        offset: (page - 1) * limit,
      };
      if (folderId) {
        params.folder_id = folderId;
      } else {
        params.no_folder = true;
      }
      if (search) {
        params.search = search;
      }
      const response = await axios.get('/api/email-campaigns', { params });
      if (response.data.success) {
        return { campaigns: response.data.campaigns, total: response.data.total, folderCounts: response.data.folderCounts || {}, folderStats: response.data.folderStats || {} };
      }
      throw new Error('Failed to load campaigns');
    } catch (error) {
      console.error('Failed to load campaigns:', error);
      throw error;
    }
  },

  /**
   * Load campaigns and trigger a refresh event for UI components
   * @returns {Promise<{campaigns, total}>}
   */
  async loadFolderStats() {
    try {
      const response = await axios.get('/api/email-campaigns/folder-stats');
      if (response.data.success) {
        return response.data.folderStats;
      }
      throw new Error('Failed to load folder stats');
    } catch (error) {
      console.error('Failed to load folder stats:', error);
      throw error;
    }
  },

  async loadCampaignsAndRefresh({ page = 1, limit = 20, folderId = null } = {}) {
    try {
      const result = await this.loadCampaigns({ page, limit, folderId });
      window.dispatchEvent(new CustomEvent('campaignsRefresh', {
        detail: result
      }));
      return result;
    } catch (error) {
      console.error('Failed to load and refresh campaigns:', error);
      throw error;
    }
  }
};